// removed by extract-text-webpack-plugin
module.exports = {"GDPRButtonWrapper":"GDPRButtonWrapper__3RXnx","GDPRButton":"GDPRButton__rfpWu","GDPRPromptText":"GDPRPromptText__2_hXB"};


//////////////////
// WEBPACK FOOTER
// ./routes/GDPROverlay/GDPROverlay.scss
// module id = 62F2
// module chunks = 0